module.exports = __webpack_public_path__ + "img/saexploration.790897c1.png";